import type { PricingMap } from "./commercial-config";
import { DEFAULT_PRICING, formatPricingEntry } from "./commercial-config";

/**
 * Single place where commercial copy resolves a price. Nothing in the UI,
 * emails or legal pages should hardcode an amount.
 */
export function priceLabel(lookupKey: string, pricing?: PricingMap): string {
  const entry = pricing?.[lookupKey] ?? DEFAULT_PRICING[lookupKey];
  if (!entry) return "—";
  return entry.label || formatPricingEntry(entry);
}

const INTERVAL_LABEL_PT: Record<string, string> = { month: "Mensal", year: "Anual" };

export function planLabelForPriceId(priceId: string | null | undefined, pricing?: PricingMap): string {
  if (!priceId) return "—";
  const entry = pricing?.[priceId] ?? DEFAULT_PRICING[priceId];
  if (!entry) return "—";
  const interval = entry.interval ? INTERVAL_LABEL_PT[entry.interval] ?? entry.interval : null;
  const amount = entry.label || formatPricingEntry(entry);
  return interval ? `${interval} · ${amount}` : amount;
}

/** "€3,99/mês" style label used in paywalls and legal copy. */
export function priceWithInterval(lookupKey: string, pricing: PricingMap | undefined, lang: "pt" | "en"): string {
  const entry = pricing?.[lookupKey] ?? DEFAULT_PRICING[lookupKey];
  if (!entry) return "—";
  const amount = entry.label || formatPricingEntry(entry);
  if (!entry.interval) return amount;
  const suffix = lang === "pt"
    ? entry.interval === "year" ? "/ano" : "/mês"
    : entry.interval === "year" ? "/year" : "/month";
  return `${amount}${suffix}`;
}
